import request from '@/utils/request';
//会员列表
//会员详情mock
export function getMemberDetail(values) {
  const { memberID } = values || {};
  return request('/member/queryMemberInfo', {
    method: 'POST',
    data: {
      id: memberID,
    },
  });
}
//总数据条数
export function getTotalData() {
  return request('/member/queryMemberCount', {
    method: 'GET',
    // data: param,
  });
}
//获取等级列表
export function getLevels() {
  return request('/config/queryLevels', {
    method: 'GET',
  });
}
//门店列表
export function getStoreList(values) {
  return request('/store/queryPage', {
    method: 'POST',
    data: values,
  });
}

//新增会员列表
export function addMember(values) {
  return request('/membership/members', {
    method: 'POST',
    data: values,
  });
}
//更新会员详情
export function updateMemberDetail(values) {
  return request('/manualOperation/updateMemberInfo', {
    method: 'POST',
    data: values,
  });
}
//积分历史mock
export function getIntegralHistory({
  page: pageNum,
  limit: pageSize,
  member_id: memberId,
}) {
  return request('/member/queryPointPage', {
    // return request('/getIntegralHistory', {
    method: 'POST',
    data: {
      pageNum,
      pageSize,
      memberId,
    },
  });
}
//分页查询型动值信息
export function getIntegralHistoryMolding(values) {
  return request('/member/queryUgcPointPage', {
    method: 'POST',
    data: values,
  });
}
//会员异动
export function memberManualOperation(values) {
  return request('/manualOperation', {
    method: 'POST',
    data: values,
  });
}
//会员批量异动
export function batchMemberManualOperation(values) {
  return request('/batchManualOperation', {
    method: 'POST',
    data: values,
  });
}
